import { Link } from '@tanstack/react-router'
import p from './pages.module.css'

export function NotFoundPage() {
  return (
    <div className={p.login}>
      <div className={p.centerState}>
        <h2>Page not found</h2>
        <p>That address doesn't match anything in DCKAP Hub.</p>
        <Link to="/" className="btn btn-dark">
          Back to DCKAP Hub
        </Link>
      </div>
    </div>
  )
}
